import { createUseStyles } from 'react-jss';
import {
  backgroundDestructiveHover,
  backgroundStatusGreen,
  backgroundStatusRed,
  label01,
  textSuccess,
} from '../../../theme';

export default createUseStyles(
  {
    root: {
      padding: [2, 12],
      display: 'inline-block',
      borderRadius: 24,
      ...label01,
    },
    success: {
      backgroundColor: backgroundStatusGreen,
      color: textSuccess,
    },
    error: {
      backgroundColor: backgroundStatusRed,
      color: backgroundDestructiveHover,
    },
  },
  {
    name: 'Badge',
  },
);
